import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function MarketAndTargetFunds({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/HedgeFunds");
    };

    const goPrev = () => {
        navigate("/BondFunds");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Money Market Funds and Target-Date Funds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    A money market fund will deal with the money market, or safe, short-term 
                </div>
                <div className="text-[#000000] text-3xl">
                    debt.  Returns are essentially guaranteed but are not substantial.
                </div>
                <div className="text-[#000000] text-3xl mt-3">
                    A target-date fund is a fund with returns dated around a certain target date.  A 
                </div>
                <div className="text-[#000000] text-3xl">
                    good target date is around retirement.  It deals with almost all investments, but its 
                </div>
                <div className="text-[#000000] text-3xl">
                    investments will become more conservative as the target date draws near.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}